module.exports = __webpack_public_path__ + "img/Data_center-B.4c6413ef.svg";